// extracted by mini-css-extract-plugin
export default {"adminAnswerBox":"AdminAnswer_adminAnswerBox__pxsCs","hasType":"AdminAnswer_hasType__qcecp"};